// todo: temporarily used this because of the problem with eslint and commit hooks, later check and fix this
/* eslint-disable */
enum IMAGE_BREAKPOINTS {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
  XXL = 'XXL'
}

enum IMAGE_SHAPES {
  SQUARE = 'SQUARE',
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}

enum IMAGE_SIZES {
  THUMBNAIL = 'THUMBNAIL',
  SIZE_1 = 'SIZE_1',
  SIZE_2 = 'SIZE_2',
  SIZE_3 = 'SIZE_3',
  SIZE_4 = 'SIZE_4',
  SIZE_5 = 'SIZE_5'
}

/* todo: later add other screen size breakpoints, beside the xs (sm, md, lg ...) */
type ImageShapesMap = Record<IMAGE_SIZES, { width: number }>;

type ImageDimensionsMap = Record<IMAGE_SHAPES, ImageShapesMap>;

type ImageBreakpointsMap = {
  threshold: number;
  dimensions: ImageDimensionsMap;
};

type ImageTypesInterface = Partial<Record<IMAGE_BREAKPOINTS, ImageBreakpointsMap>>;

const imageTypes: ImageTypesInterface = {
  [IMAGE_BREAKPOINTS.XS]: {
    threshold: 450,
    dimensions: {
      [IMAGE_SHAPES.SQUARE]: {
        [IMAGE_SIZES.THUMBNAIL]: { width: 48 },
        [IMAGE_SIZES.SIZE_1]: { width: 83 },
        [IMAGE_SIZES.SIZE_2]: { width: 170 },
        [IMAGE_SIZES.SIZE_3]: { width: 183 },
        [IMAGE_SIZES.SIZE_4]: { width: 261 },
        [IMAGE_SIZES.SIZE_5]: { width: 418 }
      },
      [IMAGE_SHAPES.HORIZONTAL]: {
        [IMAGE_SIZES.THUMBNAIL]: { width: 0 },
        [IMAGE_SIZES.SIZE_1]: { width: 76 },
        [IMAGE_SIZES.SIZE_2]: { width: 291 },
        [IMAGE_SIZES.SIZE_3]: { width: 388 },
        [IMAGE_SIZES.SIZE_4]: { width: 418 },
        [IMAGE_SIZES.SIZE_5]: { width: 450 }
      },
      [IMAGE_SHAPES.VERTICAL]: {
        [IMAGE_SIZES.THUMBNAIL]: { width: 315 },
        [IMAGE_SIZES.SIZE_1]: { width: 170 },
        [IMAGE_SIZES.SIZE_2]: { width: 0 },
        [IMAGE_SIZES.SIZE_3]: { width: 315 },
        [IMAGE_SIZES.SIZE_4]: { width: 315 },
        [IMAGE_SIZES.SIZE_5]: { width: 315 }
      }
    }
  }
};

interface ImageResizerParamObject {
  size: IMAGE_SIZES;
  shape: IMAGE_SHAPES;
  breakpoint: IMAGE_BREAKPOINTS;
}

const getImageResizerQueryParam = ({
  breakpoint,
  shape,
  size
}: ImageResizerParamObject): string => {
  return `?width=${imageTypes[breakpoint]?.dimensions[shape][size].width}`;
};

export { IMAGE_BREAKPOINTS, IMAGE_SHAPES, IMAGE_SIZES, imageTypes, getImageResizerQueryParam };
